/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { TaskTypeEnum } from './taskTypeEnum';
import type { TaskCreateRequestTitle } from './taskCreateRequestTitle';
import type { TaskCreateRequestDescription } from './taskCreateRequestDescription';
import type { TaskCreateRequestSortIndex } from './taskCreateRequestSortIndex';
import type { TaskCreateRequestEvaluation } from './taskCreateRequestEvaluation';
import type { TaskCreateRequestAnalysis } from './taskCreateRequestAnalysis';
import type { TaskCreateRequestRubric } from './taskCreateRequestRubric';
import type { TaskCreateRequestEventConfig } from './taskCreateRequestEventConfig';

/**
 * Create a Task
 */
export interface TaskCreateRequest {
  /** Type of task: 'essay' (written response), 'activity' (no written response, e.g., collect material or complete an external assignment), 'event' (scheduled/meeting). */
  type?: TaskTypeEnum;
  title?: TaskCreateRequestTitle;
  description?: TaskCreateRequestDescription;
  /**
   * @minimum 1
   * @maximum 3
   */
  level?: number;
  sortIndex?: TaskCreateRequestSortIndex;
  evaluation?: TaskCreateRequestEvaluation;
  analysis?: TaskCreateRequestAnalysis;
  rubric?: TaskCreateRequestRubric;
  eventConfig?: TaskCreateRequestEventConfig;
}
